/* Progressive enhancement: all links remain visible and usable without JS. */
(() => {
  function initialise(root = document) {
    root.querySelectorAll('[data-nph-catalog-directory]').forEach(directory => {
      if (directory.dataset.initialised) return;
      directory.dataset.initialised = 'true';
      const input = directory.querySelector('input[type="search"]');
      const links = [...directory.querySelectorAll('[data-directory-label]')];
      const status = directory.querySelector('[data-directory-status]');
      if (!input) return;
      input.addEventListener('input', () => {
        const needle = input.value.trim().toLocaleLowerCase('sv');
        let visible = 0;
        links.forEach(link => {
          link.hidden = !link.dataset.directoryLabel.toLocaleLowerCase('sv').includes(needle);
          if (!link.hidden) visible++;
        });
        if (status) status.textContent = visible ? `${visible} träffar` : 'Inga träffar. Prova ett annat sökord.';
      });
    });
  }
  initialise();
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();
